import React from "react";

import { Image } from "../../../../Atoms";
import { InputError } from "../../../FormInputs";

import theme from "../../../../../foundation/Theme";

import {
  DiscountedPrice,
  Title,
  PackageList,
  Price,
  StyledPackage,
  Tag,
  OrText,
  OrContainer,
  StyledSinglePackage,
  SingleConsultationWrapper,
  NotSure,
  SingleTitle,
} from "./style";

function Package({ data, active, setSelectedPackage, index, gtmIdPackages }) {
  const {
    image,
    title,
    price,
    discountedPrice,
    priceConstant,
    recommended,
    numberOfClasses,
  } = data;
  return (
    <StyledPackage
      id={gtmIdPackages}
      className={active ? "active" : ""}
      onClick={setSelectedPackage}
    >
      {image && active && <Image src={image} />}
      <Title variant="label1" isExtraBold>
        {title}
      </Title>

      <Title variant="label4">{numberOfClasses} Consultations</Title>
      <Price
        variant="label2"
        fontFamily="var(--man-700)"
        className={active ? "active" : ""}
      >
        {priceConstant} {price}
      </Price>
      <DiscountedPrice
        variant="heading6"
        isExtraBold
        className={active ? "active" : ""}
      >
        {priceConstant} {discountedPrice}
      </DiscountedPrice>
      {(index === 1 || recommended) && (
        <Tag variant="paragraph4" fontSize="10px" isExtraBold>
          Recommended
        </Tag>
      )}
    </StyledPackage>
  );
}

function SinglePackage({
  data = {},
  active,
  setSelectedPackage,
  gtmIdSinglePackage,
}) {
  const { image, discountedPrice, priceConstant } = data;
  return (
    <StyledSinglePackage
      id={gtmIdSinglePackage}
      className={active ? "active" : ""}
      onClick={setSelectedPackage}
    >
      {image && active && <Image src={image} />}

      <NotSure variant="paragraph2" color={theme.colorsV2.gray.shade_500}>
        Not sure yet?
      </NotSure>

      <SingleConsultationWrapper>
        <SingleTitle variant="label1" isExtraBold>
          Try Single Consultation at
        </SingleTitle>
        <DiscountedPrice
          variant="heading6"
          isExtraBold
          className={active ? "active" : ""}
        >
          {priceConstant} {discountedPrice}
        </DiscountedPrice>
      </SingleConsultationWrapper>
    </StyledSinglePackage>
  );
}

function SelectPackage({
  packageOptions,
  selectedPackageDuration,
  setSelectedPackage,
  selectedPackageDurationError,
  gtmIdPackages,
  gtmIdSinglePackage,
}) {
  const packages = packageOptions?.filter(
    ({ courseType }) => courseType === "GENERAL"
  );
  const singleConsultations = packageOptions?.filter(
    ({ courseType }) => courseType === "SPECIALIZED"
  );

  return (
    <>
      {packages.length > 0 && (
        <PackageList mb={singleConsultations.length > 0 ? "0px" : "24px"}>
          {packages?.map((pack, index) => (
            <Package
              key={pack.title}
              active={selectedPackageDuration === pack.packageSlug}
              setSelectedPackage={() => setSelectedPackage(pack.packageSlug)}
              data={pack}
              index={index}
              gtmIdPackages={gtmIdPackages}
            />
          ))}
        </PackageList>
      )}
      {singleConsultations.length > 0 && (
        <>
          {packages.length > 0 && (
            <OrContainer mt="8px" mb="12px">
              <OrText
                variant="label2"
                fontFamily="var(--man-700)"
                color={theme.colorsV2.gray.shade_400}
                fontSize="12px"
                lineHeight="24px"
              >
                OR
              </OrText>
            </OrContainer>
          )}
          {singleConsultations?.map((singleConsultation) => (
            <SinglePackage
              key={singleConsultation.title}
              active={
                selectedPackageDuration === singleConsultation.packageSlug
              }
              setSelectedPackage={() =>
                setSelectedPackage(singleConsultation.packageSlug)
              }
              data={singleConsultation}
              gtmIdSinglePackage={gtmIdSinglePackage}
            />
          ))}
        </>
      )}
      {selectedPackageDurationError && (
        <InputError
          error={selectedPackageDurationError}
          isNotAbsolute
          style={{
            marginBottom: "8px",
          }}
        />
      )}
    </>
  );
}

export default SelectPackage;
